import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import {
    getModuleExcerptAssociatedSessionModelFromDto,
    getModulePhaseProgressEnumFromType,
    getModulePhaseTrackStatusEnumFromType,
    participantSessionBaseAdapter
} from "@/3514/adapters"

import {
    type ICoachGroupSessionParticipantModulePhaseDto,
    type ICoachGroupSessionParticipantModulePhaseModel,
    type ICoachGroupSessionParticipantProgressDto,
    type ICoachGroupSessionParticipantProgressModel,
    type ICoachGroupSessionSummaryDto,
    type ICoachGroupSessionSummaryItemDto,
    type ICoachGroupSessionSummaryItemModel,
    type ICoachGroupSessionSummaryModel
} from "./coach.group.api.types"

function summaryAdapter(dto: ICoachGroupSessionSummaryDto): ICoachGroupSessionSummaryModel {
    return isEmpty(dto)
        ? null
        : {
              id: dto.id,
              summaries: isEmpty(dto.summary_data)
                  ? []
                  : map(
                        dto.summary_data,
                        (s: ICoachGroupSessionSummaryItemDto): ICoachGroupSessionSummaryItemModel => s
                    )
          }
}

function individualProgressAdapter(
    dto: ICoachGroupSessionParticipantProgressDto
): ICoachGroupSessionParticipantProgressModel {
    return isEmpty(dto)
        ? null
        : {
              ...participantSessionBaseAdapter(dto),
              module: isEmpty(dto.module_progress)
                  ? null
                  : {
                        title: dto.module_progress.title,
                        rank: dto.module_progress.rank,
                        phases: isEmpty(dto.module_progress.phases)
                            ? []
                            : map<
                                  ICoachGroupSessionParticipantModulePhaseDto,
                                  ICoachGroupSessionParticipantModulePhaseModel
                              >(
                                  dto.module_progress.phases,
                                  (
                                      phase: ICoachGroupSessionParticipantModulePhaseDto
                                  ): ICoachGroupSessionParticipantModulePhaseModel => ({
                                      id: phase.id,
                                      trackStatus: getModulePhaseTrackStatusEnumFromType(phase.track_status),
                                      progressStatus: getModulePhaseProgressEnumFromType(phase.phase_progress_bar)
                                  })
                              ),
                        associatedSession: getModuleExcerptAssociatedSessionModelFromDto(
                            dto.module_progress.associated_session
                        )
                    },
              moduleSummary: isEmpty(dto.module_summary) ? null : summaryAdapter(dto.module_summary)
          }
}

export default { summary: summaryAdapter, individualProgress: individualProgressAdapter }
